var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1023,263.1c0,-72.68 -35.2,-130.02 -102.48,-130.02c-67.57,0 -108.45,57.35 -108.45,129.45c0,85.45 48.26,128.6 117.53,128.6c33.78,0 59.33,-7.66 78.64,-18.45l0,-56.78c-19.3,9.65 -41.45,15.61 -69.55,15.61c-27.54,0 -51.95,-9.65 -55.07,-43.15l138.82,0c0,-3.69 0.57,-18.45 0.57,-25.27zm-140.24,-26.97c0,-32.08 19.59,-45.42 37.47,-45.42c17.32,0 35.77,13.34 35.77,45.42l-73.24,0z",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m702.49,133.08c-27.82,0 -45.71,13.06 -55.64,22.14l-3.69,-17.6l-62.46,0l0,331.01l70.97,-15.05l0.28,-80.34c10.22,7.38 25.27,17.88 50.25,17.88c50.82,0 97.09,-40.88 97.09,-130.87c-0.28,-82.33 -47.13,-127.18 -96.81,-127.18zm-17.03,195.6c-16.75,0 -26.69,-5.96 -33.5,-13.34l-0.28,-105.32c7.38,-8.23 17.6,-13.91 33.78,-13.91c25.83,0 43.72,28.96 43.72,66.15c0,38.04 -17.6,66.43 -43.72,66.43z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m554.3,43.37l-71.26,15.05l0,57.91l71.26,-15.33l0,-57.63z",
    id: "polygon22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m483.04,137.9l71.26,0l0,248.4l-71.26,0l0,-248.4z",
    id: "rect24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m406.68,158.91l-4.54,-21.01l-61.32,0l0,248.4l70.97,0l0,-168.35c16.75,-21.86 45.14,-17.88 53.94,-14.76l0,-65.29c-9.08,-3.41 -42.3,-9.65 -59.05,21.01z",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m264.73,76.3l-69.27,14.76l-0.28,227.39c0,42.02 31.51,72.96 73.53,72.96c23.28,0 40.31,-4.26 49.68,-9.37l0,-57.63c-9.08,3.69 -53.94,16.75 -53.94,-25.27l0,-100.78l53.94,0l0,-60.47l-53.94,0l0.28,-61.6z",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m72.82,210.01c0,-11.07 9.08,-15.33 24.13,-15.33c21.58,0 48.83,6.53 70.4,18.17l0,-66.71c-23.56,-9.37 -46.84,-13.06 -70.4,-13.06c-57.63,0 -95.95,30.09 -95.95,80.34c0,78.35 107.88,65.86 107.88,99.64c0,13.06 -11.36,17.32 -27.25,17.32c-23.56,0 -53.65,-9.65 -77.5,-22.71l0,67.57c26.4,11.36 53.09,16.18 77.5,16.18c59.05,0 99.64,-29.24 99.64,-80.06c-0.28,-84.6 -108.45,-69.55 -108.45,-101.35z",
    id: "path30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStripe);
export default __webpack_public_path__ + "static/media/ic_stripe.5163c5337e25685b6cdcb81dcf3229b8.svg";
export { ForwardRef as ReactComponent };